var _circle, _g, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgButtonIdle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 84,
    height: 84,
    viewBox: "0 0 84 84",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 42,
    cy: 42,
    r: 41.5,
    fill: "#E8E8E8",
    stroke: "#EFF0F4"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_1_2)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 42.5,
    cy: 42.5,
    r: 35.5,
    fill: "url(#paint0_linear_1_2)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.1961 29.9063C30.1299 29.397 28.9585 30.3713 29.263 31.5127L31.495 39.8528C31.5509 40.0624 31.6672 40.251 31.8294 40.3951C31.9916 40.5392 32.1925 40.6324 32.4073 40.6633L43.3503 42.2265C43.6669 42.2708 43.6669 42.7292 43.3503 42.7746L32.4084 44.3368C32.1936 44.3676 31.9927 44.4609 31.8305 44.6049C31.6683 44.749 31.552 44.9376 31.4961 45.1472L29.263 53.4917C28.9585 54.6321 30.1299 55.6064 31.1961 55.0982L54.9974 43.7511C56.0481 43.2507 56.0481 41.7538 54.9974 41.2523L31.1961 29.9063Z",
    fill: "#272727"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_1_2",
    x: 6,
    y: 6,
    width: 72,
    height: 72,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1,
    dy: -1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1_2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_2",
    x1: 15.875,
    y1: 10.2428,
    x2: 70.8317,
    y2: 72.3678,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5F6FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DBDCE0"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgButtonIdle);
export default __webpack_public_path__ + "static/media/button-idle.b2cf072cf44009912b908c5bc5496cf1.svg";
export { ForwardRef as ReactComponent };